// src/pages/auth/Login.js
// Page de connexion connectée à l'API - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';

const Login = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    if (!email.trim() || !password.trim()) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', padding: '16px', backgroundColor: theme.bg },
    header: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '32px' },
    backButton: { background: 'none', border: 'none', color: theme.textPrimary, fontSize: '20px', cursor: 'pointer' },
    logoSection: { textAlign: 'center', marginBottom: '32px' },
    logoTitle: { fontSize: '28px', fontWeight: '700', color: theme.gold },
    logoSubtitle: { fontSize: '13px', color: theme.textSecondary, marginTop: '4px' },
    form: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: theme.textSecondary },
    input: { padding: '14px 16px', backgroundColor: theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: '8px', color: theme.textPrimary, fontSize: '15px', outline: 'none' },
    errorText: { fontSize: '13px', color: '#F56565', textAlign: 'center' },
    button: { padding: '16px', backgroundColor: theme.gold, border: 'none', borderRadius: '10px', color: theme.mode === 'light' ? '#FFFFFF' : '#0A0E1A', fontSize: '16px', fontWeight: '700', cursor: 'pointer', marginTop: '8px' },
    links: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginTop: '24px' },
    link: { color: theme.gold, fontSize: '14px', cursor: 'pointer' },
    text: { color: theme.textSecondary, fontSize: '14px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Connexion | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
      </div>

      <div style={styles.logoSection}>
        <div style={styles.logoTitle}>Fynho</div>
        <div style={styles.logoSubtitle}>Find Your New Home</div>
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>Email</label>
          <input type="email" style={styles.input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Mot de passe</label>
          <input type="password" style={styles.input} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" onKeyDown={(e) => e.key === 'Enter' && handleLogin()} />
        </div>
        {error && <div style={styles.errorText}>{error}</div>}
        <button style={{ ...styles.button, opacity: loading ? 0.6 : 1 }} onClick={handleLogin} disabled={loading}>
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>
      </div>

      <div style={styles.links}>
        <span style={styles.link} onClick={() => navigate('/forgot-password')}>Mot de passe oublié ?</span>
        <span style={styles.text}>
          Pas de compte ?{' '}
          <span style={styles.link} onClick={() => navigate('/register')}>S'inscrire</span>
        </span>
      </div>
    </div>
  );
};

export default Login;